import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/purchaseOrder`;

export const ROUTE: RouteDefinition = `${baseRoute}/purchaseOrder`;

export const URL = (): RouteDefinition => `${baseRoute}/purchaseOrder`;
